<template>
  <section class="mediaList" :id="content.name">
    <h2 v-if="content.headline">{{content.headline}}</h2>

    <div class="media">
      <img v-if="content.image"
        class="mr3"
        :src="content.image.url"
        :title="content.image.title"
        :alt="content.image">
      <div class="media-body">
        <ul class="list">
          <li v-for="(element, n) in content.data" :key="n">{{element.text}}</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeatureList',
  props: {
    content: {
      type: Object,
      default() {
        return {
          headline: String,
          image: Object,
          text: String
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  img
    max-width: 100px
    border-radius: 50%
    margin-right: 1em
    float: left

  ul
    margin-top: 0

</style>
